<template>
  <div class='oversea' v-loading.fullscreen="disabled">
    <!-- <div>这个框是测试用的，正式会去掉<el-input class="login_ipt first_login_ipt" v-model="email"  placeholder="输入ID"></el-input></div> -->
    <div class="detailbg">
      <!--  <div>
        <div>审批状态：{{isPayoneer}}<br>
          0：未申请，1：审批中，2：审批通过，3：审批失败</div>
      </div> -->
      <div class="title">
        <h2 class="text_blue">Start your selling journey on
          Card Hobby</h2>
      </div>
      <div style="text-align: center;">
        <div class="text_blue text_2xl">Grow your hobby business with Card Hobby:</div>
        <div style="text-align: center;width: 50%;margin: 46px auto;">
          <img style="width:80%" src="/static/images/activty/becomeseller/becomeseller_07.png">
          <p style="text-align: left;margin-left: 16px;margin-top: 10px;">Connect to nearly millions of collectibles
            buyers around the world</p>
        </div>
      </div>
      <div style="line-height: 1.5;">
        <h4 class="text_xl" style="line-height: 2;">Start your business now:</h4>
        <div>1. Sign a settlement agreement with Payoneer.</div>
        <div>2. Wait 5-6 working days for the seller audit by Card Hobby.</div>
        <div>3. Start selling.</div>
      </div>
      <div><img class='b5' src="/static/images/activty/becomeseller/becomeseller_05.png"></div>

      <div style="margin-top: 70px;">
        <h4 class="text_xl" style="line-height: 2;">Exclusive Cardhobby Vault Consignment Service</h4>
        <div style="display: flex;    gap: 4px;">1. <span>Cards remain in Cardhobby insured climate-controlled vault, <br/>save international withdrawal, customs and
          shipping costs.</span></div>
        <div style="display: flex;margin: 4px 0;    gap: 4px;">2. <span>Complete transactions via vault-to-vault ownership transfer, <br/>avoid transit damage & delivery delays.</span>
        </div>
        <div>3. Platform fund escrow , verification for order security.</div>
      </div>
      <div>
        <div class="sellerCheckbox b4">
          <el-checkbox v-model="isAgreement"> </el-checkbox>
          <div class="checkBoxText">
          <p>
            I agree to the <router-link class="text_blue" :to="{ path: '/app/privacy?type=6' }"
                target="_blank">Seller Onboarding Agreement</router-link> and <router-link class="text_blue" :to="{ path: '/app/privacy?type=21' }"
                target="_blank">Consignment Service Terms</router-link>
          </p>
          </div>
          <!-- <div class="checkBoxText">
            <i18n path="base.agreeTo2" tag="p">
              <router-link class="text_blue" :to="{ path: '/app/privacy?type=6' }"
                target="_blank">{{ $t('title.settlementAgreement') }}</router-link>
            </i18n>

          </div> -->
        </div>
      </div>
      <div class="text_lg">* Enabling Vault service means you accept the Supplementary Terms for Cardhobby Vault Consignment attached to the agreement</div>
      <div class="btn_box"><img class='b6'
          src="/static/images/activty/becomeseller/becomeseller_08.png"><span @click="ShippingFee(1)"></span><span
          @click="ShippingFee(0)"></span></div>
      <!-- <div><img class='b1' src="/static/images/activty/becomeseller/becomeseller_01.png"></div>
      <div><img class='b2' src="/static/images/activty/becomeseller/becomeseller_02.png"></div>
      <div><img class='b3' src="/static/images/activty/becomeseller/becomeseller_03.png"></div>
      <div><img class='b4' :src="imageStart"></div>
      <div><img class='b5' src="/static/images/activty/becomeseller/becomeseller_05.png"></div>
      <div>
        <div class="sellerCheckbox b4">
          <el-checkbox v-model="isAgreement"> </el-checkbox>

          <div class="checkBoxText">
            <i18n path="base.agreeTo2" tag="p">
              <router-link class="text_blue" :to="{ path: '/app/privacy?type=6' }"
                target="_blank">{{ $t('title.settlementAgreement') }}</router-link>
            </i18n>

          </div>
        </div>
      </div> -->
      <!-- <div v-if="isPayoneer == 0 || isPayoneer == 3"><img class='b6'
          src="/static/images/activty/becomeseller/becomeseller_06.png"><span @click="ShippingFee(1)"></span><span
          @click="ShippingFee(0)"></span></div>
      <div style="height:80px;" v-if="isPayoneer != 0 && isPayoneer != 3"></div> -->
      <!-- <img src="/static/images/activty/becomeseller/detailbg.png"><span @click="ShippingFee"></span> -->
    </div>
    <!-- <div>这个框是测试用的，正式会去掉<el-input class="login_ipt first_login_ipt" v-model="email"  placeholder="输入ID"></el-input></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_01.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_02.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_03.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_04.jpg"><span @click="ShippingFee"></span></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_05.jpg"></div> -->
  </div>
</template>
<script>
import { getInfo, setInfo } from "@/api/public";
export default {
  name: '',
  components: {},
  data() {
    return {
      imageStart: "/static/images/activty/becomeseller/becomeseller_04.png",
      isPayoneer: 0,
      isStripe: false,
      disabled: false,
      userInfo: getInfo(),
      isAgreement: false
    }
  },
  watch: {},
  mounted() {
    this.StripeConfig()
  },
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.becomeASeller'));
    this.userInfo = getInfo();
    this.getUserDetail()
  },
  methods: {
    // 获取用户详情
    getUserDetail() {
      this.disabled = true;
      let that = this;
      if (this.userInfo != null) {
        let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        that.$get(this.$interface.GetUserDetail, data).then(res => {
          if (res.result != 0) {
            let data = res.data;
            //that.userDetail = data;
            //console.log('getUserDetail', data)
            setInfo('PointCount', data.PointCount)
            setInfo('SumMoney', data.SumMoney)
            setInfo('HeadPortrait', data.HeadPortrait)
            setInfo('MemberSource', data.MemberSource)
            setInfo('WyAccId', data.WyAccId)
            setInfo('WyToken', data.WyToken)
            setInfo('AccountId', data.AccountId)
            that.userInfo = getInfo();
            // todo
            // if (that.userInfo.MemberSource != 'US') {
            //   that.imageStart = "/static/images/activty/becomeseller/becomeseller_NOUS.png"
            // }
            that.getMemberInfo()
          }
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    // 获取用户详情
    getMemberInfo() {
      let that = this;
      let data = { memberId: that.userInfo.Id }
      that.$get(this.$interface.GetMemberInfo, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data;
          // that.memberInfo = data;
          //console.log('memberInfo', data)
          //setInfo('HeadPortrait',data.HeadPortrait)
          setInfo('LocationIcon', data.LocationIcon)
          setInfo('LocationName', data.LocationName)
          setInfo('IsSeller', data.IsSeller)
          that.userInfo = getInfo();

          this.disabled = false;

          if (data.IsSeller == true) {
            window.location.href = process.env.VUE_APP_SELL_URL
          }
          // else {
          //   // if (that.userInfo.MemberSource != 'US') {
          //   //   //that.PayoneerConfig()
          //   // }
          // }
        }
      })
    },
    ShippingFee(val) {
      // let url='/login'
      // url=process.env.VUE_APP_INTLPAY+'/user/SetInfo?id='+this.email //+this.userInfo.MappingUserId
      // window.location.href=url;
      //   console.log(url)
      let that = this
      if (!that.isStripe) {
        this.$message({
          message: this.$t('alert.Stripeallowlist'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
          duration: 5000
        });
        return
      }
      let url = '/login'
      this.disabled = true;
      if (this.userInfo != null) {
        url = process.env.VUE_APP_INTLPAY + '/user/SetInfo?id=' + this.userInfo.MappingUserId //+this.userInfo.MappingUserId
        if (val == 1) {
          url = process.env.VUE_APP_INTLPAY + '/user/SetCompany?id=' + this.userInfo.MappingUserId
        }
        // todo 派安颖
        // if (that.userInfo.MemberSource != 'US') {
        //   url = this.$interface.PayoneerLink + '?Id=' + that.userInfo.MappingUserId + '&UserType=1';
        //   if (val == 1) {
        //     url = this.$interface.PayoneerLink + '?Id=' + that.userInfo.MappingUserId + '&UserType=2';
        //   }
        // }
        if (!this.isAgreement) {
          this.$confirm(`<div style="padding: 0 24px;">` + that.$t('alert.toProceed2') + ` <a href="#/terms/privacy?type=6"  target="_blank" class="text_blue">` + that.$t('title.settlementAgreement') + `</a> `, that.$t('base.notice'), {
            // showConfirmButton: true ,
            customClass: "NoticeBox",
            dangerouslyUseHTMLString: true,
            confirmButtonText: that.$t('base.agree'),
            cancelButtonText: that.$t('base.cancel'),
          }).then(() => {
            this.isAgreement = true;
            window.location.href = url;
          })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          window.location.href = url;
        }

      } else {
        this.$router.push({
          path: url
        })
      }
    },
    StripeConfig() {
      const that = this
      let data = { Id: that.userInfo.MappingUserId }
      that.$get(this.$interface.StripeConfig, data).then(res => {
        that.isStripe = res.Data
      })
    },
    //获取用户是否开通Payoneer
    //0：未申请，1：审批中，2：审批通过，3：审批失败
    PayoneerConfig() {
      let that = this
      let data = { id: that.userInfo.MappingUserId }
      that.$get(this.$interface.PayoneerConfig, data).then(res => {
        if (res.Result == 1) {
          that.isPayoneer = res.Data
          if (that.isPayoneer == 2) {
            // window.location.href = process.env.VUE_APP_SELL_URL
          }
          if (that.isPayoneer == 1) {
            this.$router.push({
              path: "/terms/merchants"
            })
          }
        }
      })
    }
  },
}

</script>
<style scoped>
.oversea {
  background-color: rgba(240, 243, 255, 1);
  width: 100%;
  position: relative;
}

.oversea:before {
  content: "";
  background: url(../../../static/images/activty/becomeseller/bg.jpg) center;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  /*  transform: rotate(-45deg);*/
}

.detailbg {
  width: 665px;
  position: relative;
  margin: 0 auto;
}

.detailbg img {
  width: 665px;
  display: block;
  overflow: hidden;
  margin: 0 auto;
}

.detailbg>div {
  position: relative;
}

.detailbg>.btn_box span {
  position: absolute;
  cursor: pointer;
  width: 161px;
  height: 41px;
  top: 40px;
  left: 164px;
}

.detailbg>div span:last-child {
  left: auto;
  right: 164px;
}

.detailbg .b1 {
  margin-top: 52px;
}

.detailbg .b2 {
  width: 476px;
}

.detailbg .b3 {
  width: 307px;
  margin-top: 50px;
}

.detailbg .b4 {
  width: 616px;
  margin-top: 48px;
}

.detailbg .b5 {
  width: 572px;
  margin-top: 72px;
}

.detailbg .b6 {
  width: 557px;
  margin-top: 32px;
  margin-bottom: 32px;
}

.oversea>div {
  position: relative;
}

.oversea>div>span {
  position: absolute;
  width: 100%;
  height: 80px;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

.sellerCheckbox {
  width: 80%;
  display: flex;
  align-items: baseline;
  margin: 30px 0 10px;
  /* margin-left: 50px; */
  font-size: 16px;
}

.checkBoxText {
  margin-left: 22px;
}

.title h2 {
  text-align: center;
  font-size: 48px;
  line-height: 1.5;
}
.detailbg{
  padding:50px 0
}
.detailbg>.btn_box span{
  top:0
}
.detailbg>.btn_box span:last-child{}

</style>



// WEBPACK FOOTER //
// src/components/activity/becomeseller.vue